import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/pencil-icon.svg'
import _imports_1 from '@/assets/close-icon-2.svg'
import _imports_2 from '@/assets/attach-icon.svg'


const _hoisted_1 = { class: "fixed inset-0 bg-black bg-opacity-80 justify-center items-center z-50 transition-opacity duration-300 ease-in-out p-4" }
const _hoisted_2 = { class: "flex flex-col max-w-[819px] h-[calc(100vh-32px)] overflow-hidden p-6 mx-auto rounded-primary-radius bg-[#FFFFFF]" }
const _hoisted_3 = { class: "flex items-center justify-between pb-[16px] border-b border-[#E3E1EA]" }
const _hoisted_4 = { class: "flex items-center justify-start gap-2" }
const _hoisted_5 = { class: "text-[14px] tracking-[0.01rem] text-primary-text-color font-medium py-[2px] px-[6px] rounded-primary-radius bg-[#A7A5AE]" }
const _hoisted_6 = {
  key: 0,
  class: "text-[12px] tracking-[0.01rem] text-white font-semibold py-[2px] px-[6px] rounded-primary-radius bg-[#D97706]",
  title: "Signatures are saved but the PDF was not regenerated. Use Force Regenerate below."
}
const _hoisted_7 = { class: "h-[calc(100vh-190px)] overflow-y-auto" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex items-center gap-2 mt-3 mb-[24px]" }
const _hoisted_10 = { class: "h-[30px] w-[30px] bg-[#E8E7FB] rounded-full flex items-center justify-center" }
const _hoisted_11 = { class: "text-lg leading-[30px] tracking-[0.01rem] font-medium text-primary-text-color" }
const _hoisted_12 = { class: "text-lg leading-[30px] tracking-[0.01rem] font-semibold text-primary-text-color" }
const _hoisted_13 = {
  key: 0,
  class: "w-full flex flex-col items-start gap-5"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "pb-[6px] text-base leading-[26px] tracking-[0.01rem] font-medium text-[#898790]" }
const _hoisted_16 = ["disabled", "onUpdate:modelValue"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "w-[67%]" }
const _hoisted_19 = { class: "text-base leading-[26px] tracking-[0.01rem] font-medium text-primary-text-color" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "flex flex-col gap-2 my-5" }
const _hoisted_24 = ["name", "value", "onChange"]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "flex flex-col gap-2 my-5" }
const _hoisted_27 = ["name", "value", "onChange"]
const _hoisted_28 = { class: "mt-auto w-full flex items-center justify-between pt-3 border-t border-[#E3E1EA]" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "flex items-center gap-4 ml-auto"
}
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 2,
  class: "flex items-center gap-4 ml-auto"
}
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "w-6 h-6 border-4 border-white border-t-transparent rounded-full animate-spin"
}
const _hoisted_36 = { key: 1 }

import client from "@/utils/axios";
import { errorToast, successToast } from "@/utils/custom-toast";
import { getStatusByName } from "@/utils/report-status";
import { computed, reactive, ref } from "vue";
import RadioButtonsTextComponent from "../RadioButtonsTextComponent.vue";
import { onMounted } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  termin: any;
  data: any;
};

type Emits = {
  (event: "close"): void;
  (event: "refresh"): void;
  (event: "uploadSignedVersion"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'AbnameProtocolModal',
  props: {
    termin: {},
    data: {}
  },
  emits: ["close", "refresh", "uploadSignedVersion"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const state = ref(props.data);
const isLoading = ref(false);
const isReportLoading = ref(false);
const abnahmeprotokollInputReportData = ref();
const { t } = useTranslate();

const structure = computed(() => {
  let groups = [];
  if (abnahmeprotokollInputReportData.value) {
    groups = abnahmeprotokollInputReportData.value
      .filter(
        (item: any) => item.type === "group" || item.type === "addMoreInput"
      )
      .map((item: any) => {
        let children = abnahmeprotokollInputReportData.value.filter(
          (child: any) => child.parentId === item.id
        );
        return {
          id: item.id,
          name: item.name,
          children: children.sort((a: any, b: any) => a.order - b.order),
          order: item.order,
        };
      });
    initializeFormState();

    return groups.sort((a: any, b: any) => a.order - b.order);
  }
  return [];
});
const formState: any = reactive({});
const dynamicFields = ref<any>({
  nichtVerbauteMaterialien: [
    {
      id: 1,
      value: "",
    },
  ],
  zusatzlichVerbauteMaterialien: [
    {
      id: 1,
      value: "",
    },
  ],
});

// Get all the allready exisitng inputs
const getAbnahmerProtokollReportInputsData = async () => {
  try {
    let resp = await client.get(
      `/termin/${props.termin.id}/abnahmeprotokoll-report-inputs`
    );
    abnahmeprotokollInputReportData.value = resp.data;
  } catch (error: any) {
    errorToast(error);
  }
};

const onChangeInput = (name: any, value: any, propertyName?: string) => {
  if (propertyName) {
    let inputIndex = dynamicFields.value[propertyName].findIndex(
      (item: any) => item.id === Number(name)
    );

    let tempList = [...dynamicFields.value[propertyName]];
    if (inputIndex != -1) {
      tempList[inputIndex].value = value;
      dynamicFields.value[propertyName] = tempList;
    }
  }
};

const addNewInputString = (propertyName: string) => {
  dynamicFields.value[propertyName].push({
    id: dynamicFields.value[propertyName].length + 1,
    value: "",
  });
};

// Function to initialize formState dynamically
const initializeFormState = () => {
  if (abnahmeprotokollInputReportData.value) {
    let addMoreInputs = abnahmeprotokollInputReportData.value.filter(
      (item: any) => item.type === "addMoreInput"
    );
    let tempFields: any = {};
    addMoreInputs.forEach((item: any) => {
      if (item.id === 33) {
        if (item.value && item.value.length > 0) {
          tempFields.nichtVerbauteMaterialien = item.value.map(
            (item: any, index: any) => {
              return {
                id: index + 1,
                value: item,
              };
            }
          );
        } else {
          tempFields.nichtVerbauteMaterialien = [
            {
              id: 1,
              value: "",
            },
          ];
        }
      } else if (item.id === 35) {
        if (item.value && item.value.length > 0) {
          tempFields.zusatzlichVerbauteMaterialien = item.value.map(
            (item: any, index: any) => {
              return {
                id: index + 1,
                value: item,
              };
            }
          );
        } else {
          tempFields.zusatzlichVerbauteMaterialien = [
            {
              id: 1,
              value: "",
            },
          ];
        }
      }
      dynamicFields.value = tempFields;
    });

    let inputs = abnahmeprotokollInputReportData.value.filter(
      (item: any) => item.type !== "group" && item.type !== "addMoreInput"
    );

    inputs.forEach((item: any) => {
      if (item.type === "text") {
        formState[`input${item.id}`] = {
          value: item.value ? item.value[0] : "",
          error: false,
        };
      } else if (item.type === "radio") {
        formState[`input${item.id}`] = {
          value: item.value ? item.value[0] : "",
          error: false,
        };
        formState[`comment${item.id}`] = item.comment;
      }
    });
  }
};

const onUpdateRadioValue = (inputId: number, radioValue: string) => {
  formState[`input${inputId}`] = {
    value: radioValue,
    error: false,
  };
};

const onUpdateCommentValue = (index: number, commentValue: string) => {
  formState[`comment${index}`] = commentValue;
};

const validate = () => {
  let formValid = true;
  abnahmeprotokollInputReportData.value.forEach((input: any) => {
    if (formState[`input${input.id}`]) {
      if (formState[`input${input.id}`].value) {
        formState[`input${input.id}`].error = false;
        formValid = false;
      } else {
        formState[`input${input.id}`].error = true;
      }
    }
  });
  return formValid;
};

const onSubmit = async () => {
  isLoading.value = true;

  try {
    let postData = {};
    abnahmeprotokollInputReportData.value.forEach((input: any) => {
      if (input.type === "text") {
        postData[`input${input.id}`] =
          formState[`input${input.id}`].value || "";
      } else if (input.type === "radio") {
        postData[`input${input.id}`] =
          formState[`input${input.id}`].value || "";
        postData[`comment${input.id}`] = formState[`comment${input.id}`] || "";
      }
    });

    let input33Values = dynamicFields.value.nichtVerbauteMaterialien.map(
      (item: any) => item.value
    );
    let input35Values = dynamicFields.value.zusatzlichVerbauteMaterialien.map(
      (item: any) => item.value
    );
    postData = {
      ...postData,
      input33: input33Values,
      input35: input35Values,
    };

    await client.post(
      `/termin/${props.termin.id}/save-abnahmeprotokoll-report`,
      {
        data: postData,
        terminId: props.termin.id,
      }
    );

    isLoading.value = false;
    successToast("Successfully saved report.");
    emits("refresh");
  } catch (error: any) {
    isLoading.value = false;
    errorToast(error);
  }
};

const generateReport = async () => {
  isReportLoading.value = true;
  validate();

  try {
    let postData = {};

    abnahmeprotokollInputReportData.value.forEach((input: any) => {
      if (input.type === "text") {
        postData[`input${input.id}`] =
          formState[`input${input.id}`].value || "";
      } else if (input.type === "radio") {
        postData[`input${input.id}`] =
          formState[`input${input.id}`].value || "";
        postData[`comment${input.id}`] = formState[`comment${input.id}`] || "";
      }
    });

    let input33Values = dynamicFields.value.nichtVerbauteMaterialien.map(
      (item: any) => item.value
    );
    let input35Values = dynamicFields.value.zusatzlichVerbauteMaterialien.map(
      (item: any) => item.value
    );
    postData = {
      ...postData,
      input33: input33Values,
      input35: input35Values,
    };

    let keys = Object.keys(postData);

    let isFormValid = true;
    for (let index = 0; index < keys.length; index++) {
      const element = keys[index];
      if (element.includes("input33") || element.includes("input35")) {
        continue;
      }
      if (element.includes("input")) {
        if (!postData[`${element}`]) {
          isFormValid = false;
        }
      }
    }
    if (!isFormValid) {
      errorToast("Cannot generate report with empty fields.");
      isReportLoading.value = false;
      return;
    }

    successToast("Your report is being generated, please wait.");

    await client.post(
      `/termin/${props.termin.id}/save-abnahmeprotokoll-report`,
      {
        data: postData,
        terminId: props.termin.id,
      }
    );

    await client.post(
      `/termin/${props.termin.id}/generate-abnahmeprotokoll-report`,
      {
        data: state.value,
      }
    );
    isReportLoading.value = false;
    emits("refresh");
    successToast("Successfully generated report.");
  } catch (error: any) {
    isReportLoading.value = false;
    errorToast(error);
  }
};

// Force-regenerate: used to recover reports where signatures were stored but
// the PDF never got updated (pdf_stale=true), or to re-render a signed report.
// Skips input validation/save — re-uses whatever is currently in the DB.
const forceRegenerateReport = async () => {
  isReportLoading.value = true;
  try {
    successToast("Forcing PDF regeneration, please wait.");
    await client.post(
      `/termin/${props.termin.id}/generate-abnahmeprotokoll-report?force=true`,
      { force: true }
    );
    isReportLoading.value = false;
    emits("refresh");
    successToast("Successfully regenerated PDF.");
  } catch (error: any) {
    isReportLoading.value = false;
    errorToast(error);
  }
};

onMounted(async () => {
  await getAbnahmerProtokollReportInputsData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("img", {
            src: _imports_0,
            alt: "Icon"
          }, null, -1)),
          _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "text-primary-text-color text-xl leading-[32px] font-semibold tracking-[0.01rem]" }, " Abnahmeprotokoll ", -1)),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(getStatusByName)(state.value?.status)), 1),
          (state.value?.pdf_stale)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, " PDF outdated "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close'))),
          class: "cursor-pointer",
          src: _imports_1,
          alt: "Close icon"
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        (structure.value && structure.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(structure.value, (group, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: group.id,
                  class: "mt-5"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(index + 1), 1)
                    ]),
                    _createElementVNode("h3", _hoisted_12, _toDisplayString(group.name), 1)
                  ]),
                  (group.children && group.children.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (child) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: child.id,
                            class: "w-full"
                          }, [
                            (child.type === 'text' && !child.qcViewType)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("p", _hoisted_15, _toDisplayString(child.name), 1),
                                  _withDirectives(_createElementVNode("input", {
                                    disabled: state.value?.status === 'signed',
                                    "onUpdate:modelValue": ($event: any) => ((formState[`input${child.id}`].value) = $event),
                                    class: _normalizeClass(["p-3 mb-1 rounded-primary-radius border resize-none w-full outline-none bg-[#F9F8F6] text-black text-base leading-[26px] tracking-[0.01rem] font-medium placeholder:text-[#898790]", `
                    ${
                      formState[`input${child.id}`].error
                        ? 'border-[#ED857F]'
                        : ''
                    } 
                    ${
                      !formState[`input${child.id}`].error &&
                      !formState[`input${child.id}`].value
                        ? 'border-[#E3E1EA]'
                        : ''
                    } 
                    ${
                      formState[`input${child.id}`].value &&
                      formState[`input${child.id}`].value.length > 0
                        ? 'border-[#393840]'
                        : ''
                    } `]),
                                    type: "text"
                                  }, null, 10, _hoisted_16), [
                                    [_vModelText, formState[`input${child.id}`].value]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (child.type === 'text' && child.qcViewType === 'card')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["flex gap-5 bg-transparent p-2 rounded-primary-radius border border-[#DFDEDC]", `
                    ${
                      formState[`input${child.id}`].error
                        ? 'border-[#ED857F]'
                        : ''
                    } 
                    ${
                      !formState[`input${child.id}`].error &&
                      !formState[`input${child.id}`].value
                        ? 'border-[#E3E1EA]'
                        : ''
                    } 
                    ${
                      formState[`input${child.id}`].value &&
                      formState[`input${child.id}`].value.length > 0
                        ? 'border-[#393840]'
                        : ''
                    } `])
                                  }, [
                                    _createElementVNode("div", _hoisted_18, [
                                      _createElementVNode("p", _hoisted_19, _toDisplayString(child.name), 1)
                                    ]),
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": ($event: any) => ((formState[`input${child.id}`].value) = $event),
                                      placeholder: "Wert",
                                      class: "w-[33%] text-primary-text-color text-base leading-[26px] tracking-[0.01rem] font-normal bg-[#F9F8F6] p-3 border border-[#E3E1EA] rounded-primary-radius resize-none outline-none focus:border focus:border-[#393840]"
                                    }, null, 8, _hoisted_20), [
                                      [_vModelText, formState[`input${child.id}`].value]
                                    ])
                                  ], 2)
                                ]))
                              : _createCommentVNode("", true),
                            (child.type === 'radio')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createVNode(RadioButtonsTextComponent, {
                                    "input-class": `${
                      formState[`input${child.id}`].error
                        ? 'border-[#ED857F]'
                        : ''
                    } ${
                      !formState[`input${child.id}`].error &&
                      !formState[`input${child.id}`].value
                        ? 'border-[#E3E1EA]'
                        : ''
                    } ${
                      formState[`input${child.id}`].value &&
                      formState[`input${child.id}`].value.length > 0
                        ? 'border-[#393840]'
                        : ''
                    } `,
                                    disabled: state.value?.status === 'signed',
                                    text: child.name,
                                    options: child.options,
                                    "radio-value": formState[`input${child.id}`].value,
                                    "comment-value": formState[`comment${child.id}`],
                                    onUpdateRadio: ($event: any) => (onUpdateRadioValue(child.id, $event)),
                                    onUpdateComment: ($event: any) => (onUpdateCommentValue(child.id, $event))
                                  }, null, 8, ["input-class", "disabled", "text", "options", "radio-value", "comment-value", "onUpdateRadio", "onUpdateComment"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (group.id === 33)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dynamicFields.value.nichtVerbauteMaterialien, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item,
                              class: "flex"
                            }, [
                              _createElementVNode("input", {
                                placeholder: "Materialien hinzufügen",
                                name: item.id,
                                class: "w-full bg-[#F9F8F6] outline-none text-primary-text-color text-base leading-[26px] tracking-[0.01rem] font-normal p-[11px] rounded-primary-radius border border-[#E3E1EA] placeholder:text-[#898790]",
                                type: "text",
                                value: item.value,
                                onChange: 
                    (event) =>
                      onChangeInput(
                        item.id,
                        event.target.value,
                        'nichtVerbauteMaterialien'
                      )
                  
                              }, null, 40, _hoisted_24)
                            ]))
                          }), 128)),
                          _createElementVNode("div", {
                            class: "hover:cursor-pointer mx-auto mt-3 flex justify-center",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (addNewInputString('nichtVerbauteMaterialien')))
                          }, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("svg", {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10Z",
                                fill: "white"
                              }),
                              _createElementVNode("path", {
                                d: "M6 10H10M10 10H14M10 10V14M10 10V6M10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19Z",
                                stroke: "#393840",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1)
                          ]))])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (group.id === 35)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dynamicFields.value.zusatzlichVerbauteMaterialien, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item,
                              class: "flex"
                            }, [
                              _createElementVNode("input", {
                                name: item.id,
                                placeholder: "Materialien hinzufügen",
                                class: "w-full bg-[#F9F8F6] outline-none text-primary-text-color text-base leading-[26px] tracking-[0.01rem] font-normal p-[11px] rounded-primary-radius border border-[#E3E1EA] placeholder:text-[#898790]",
                                type: "text",
                                value: item.value,
                                onChange: 
                    (event) =>
                      onChangeInput(
                        item.id,
                        event.target.value,
                        'zusatzlichVerbauteMaterialien'
                      )
                  
                              }, null, 40, _hoisted_27)
                            ]))
                          }), 128)),
                          _createElementVNode("div", {
                            class: "hover:cursor-pointer mx-auto mt-3 flex justify-center",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (addNewInputString('zusatzlichVerbauteMaterialien')))
                          }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("svg", {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _createElementVNode("path", {
                                d: "M1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10Z",
                                fill: "white"
                              }),
                              _createElementVNode("path", {
                                d: "M6 10H10M10 10H14M10 10V14M10 10V6M10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19Z",
                                stroke: "#393840",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              })
                            ], -1)
                          ]))])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        (state.value?.status !== 'signed')
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('uploadSignedVersion'))),
                class: "flex items-center gap-1 py-3 px-[16px] text-base text-primary-text-color bg-transparent tracking-[0.01rem] font-semibold outline-none rounded-primary-radius border-[2px] border-[#393840] cursor-pointer duration-200"
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("img", {
                  src: _imports_2,
                  alt: ""
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(t)("phase.add_signed_version")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (state.value?.status === 'signed' || state.value?.pdf_stale)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("button", {
                disabled: isReportLoading.value,
                onClick: forceRegenerateReport,
                class: "flex items-center gap-1 py-3 px-[16px] text-base text-white bg-[#D97706] tracking-[0.01rem] font-semibold outline-none rounded-primary-radius border-[2px] border-[#D97706] cursor-pointer hover:bg-[#B45309] duration-200"
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  width: "14",
                  height: "16",
                  viewBox: "0 0 14 16",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  class: _normalizeClass(`${isReportLoading.value ? 'animate-spin' : ''}`)
                }, [...(_cache[9] || (_cache[9] = [
                  _createElementVNode("path", {
                    d: "M5.50024 11H1.75024V14.75M8.50024 5H12.2502V1.25M1.4375 5.75255C1.85801 4.71175 2.56207 3.80978 3.46966 3.14917C4.37724 2.48856 5.45289 2.09564 6.57256 2.01538C7.69223 1.93512 8.81129 2.17055 9.80382 2.69496C10.7963 3.21937 11.6212 4.0119 12.1858 4.98209M12.5634 10.2478C12.1429 11.2886 11.4388 12.1906 10.5312 12.8512C9.62367 13.5118 8.54912 13.9042 7.42944 13.9845C6.30977 14.0647 5.18979 13.8293 4.19727 13.3049C3.20474 12.7805 2.37936 11.9881 1.8147 11.0179",
                    stroke: "#ffffff",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1)
                ]))], 2)),
                _cache[10] || (_cache[10] = _createTextVNode(" Force Regenerate ", -1))
              ], 8, _hoisted_31)
            ]))
          : _createCommentVNode("", true),
        (state.value?.status !== 'signed')
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("button", {
                disabled: isReportLoading.value,
                onClick: generateReport,
                class: "flex items-center gap-1 py-3 px-[16px] text-base text-primary-text-color bg-transparent tracking-[0.01rem] font-semibold outline-none rounded-primary-radius border-[2px] border-[#393840] cursor-pointer duration-200"
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  width: "14",
                  height: "16",
                  viewBox: "0 0 14 16",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  class: _normalizeClass(`${isReportLoading.value ? 'animate-spin' : ''}`)
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("path", {
                    d: "M5.50024 11H1.75024V14.75M8.50024 5H12.2502V1.25M1.4375 5.75255C1.85801 4.71175 2.56207 3.80978 3.46966 3.14917C4.37724 2.48856 5.45289 2.09564 6.57256 2.01538C7.69223 1.93512 8.81129 2.17055 9.80382 2.69496C10.7963 3.21937 11.6212 4.0119 12.1858 4.98209M12.5634 10.2478C12.1429 11.2886 11.4388 12.1906 10.5312 12.8512C9.62367 13.5118 8.54912 13.9042 7.42944 13.9845C6.30977 14.0647 5.18979 13.8293 4.19727 13.3049C3.20474 12.7805 2.37936 11.9881 1.8147 11.0179",
                    stroke: "#393840",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1)
                ]))], 2)),
                _createTextVNode(" " + _toDisplayString(_unref(t)("phase.generate_report")), 1)
              ], 8, _hoisted_33),
              _createElementVNode("button", {
                onClick: onSubmit,
                disabled: isLoading.value,
                class: "w-[150px] flex items-center justify-center py-3 px-[56px] text-base text-white bg-[#393840] tracking-[0.01rem] font-semibold outline-none rounded-primary-radius border-[2px] border-[#393840] cursor-pointer hover:bg-[#28272c] duration-200"
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                  : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_unref(t)("global.save")), 1))
              ], 8, _hoisted_34)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})